import { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { api } from '../api';
import type { TeamMember } from '../types';

type Props = { onSelect: (name: string, isAdmin: boolean, key?: string) => void };

export function Landing({ onSelect }: Props) {
  const [team, setTeam] = useState<TeamMember[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.team.list().then(t => { setTeam(t); setLoading(false); });
  }, []);

  return (
    <div
      className="min-h-[100dvh] flex flex-col safe-x"
      style={{ paddingTop: 'env(safe-area-inset-top)', paddingBottom: 'env(safe-area-inset-bottom)' }}
    >
      <div className="flex-1 flex flex-col justify-center pt-8">
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3 }}
          className="px-2"
        >
          <div className="flex items-center gap-3 mb-8">
            <img src="/logo.png" alt="Coastline K9" className="h-12 w-12 object-contain" />
            <div>
              <div className="font-heading text-3xl leading-none">COASTLINE&nbsp;K9</div>
              <div className="text-[11px] uppercase tracking-widest text-coast-muted mt-1">
                Weekly Team Retro
              </div>
            </div>
          </div>

          <h1 className="font-heading text-4xl leading-tight mb-2">
            Who&apos;s checking in?
          </h1>
          <p className="text-coast-muted text-base mb-6">
            Tap your name. Your answers go privately to Erick — no one else sees them.
          </p>

          <div className="space-y-2">
            {loading && <div className="text-coast-muted">Loading team…</div>}
            {team.map(m => (
              <button
                key={m.id}
                className="w-full flex items-center justify-between px-4 py-4
                           border border-coast-hairline bg-coast-card
                           active:border-coast-blue active:bg-coast-black"
                onClick={() => {
                  if (m.isAdmin) {
                    const code = window.prompt('Admin passcode (Erick only):') || '';
                    if (!code) return;
                    onSelect(m.name, true, code);
                  } else {
                    onSelect(m.name, false);
                  }
                }}
                style={{ minHeight: 60 }}
              >
                <div className="flex items-center gap-3">
                  <div
                    className={`h-9 w-9 flex items-center justify-center font-heading text-lg
                               ${m.isAdmin ? 'bg-coast-blue text-coast-black' : 'bg-coast-hairline text-coast-white'}`}
                  >
                    {m.name.split(' ').map(x => x[0]).join('').slice(0, 2).toUpperCase()}
                  </div>
                  <div className="text-left">
                    <div className="text-base leading-tight">{m.name}</div>
                    <div className="text-[10px] uppercase tracking-widest text-coast-muted">
                      {m.role.replace('_', ' ')}
                    </div>
                  </div>
                </div>
                <div className="text-coast-blue text-xl leading-none">›</div>
              </button>
            ))}
          </div>
        </motion.div>
      </div>

      <div className="pt-8 pb-2 text-center text-[10px] uppercase tracking-widest text-coast-muted">
        Private · Answers go to Erick only
      </div>
    </div>
  );
}
